// Generated types for ModelResponse
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ModelResponseReadAPI extends Omit<ScopedNodeReadAPI, 'created_at'> {
  /** When response was created */
  created_at?: string | null;
  /** Name of the model that generated this response */
  model_name?: string | null;
  /** Provider that generated this response (e.g. 'google-gla'). Providers gate thought-signature replay on this matching, so it must survive the history rebuild. */
  provider_name?: string | null;
  /** Whether response is being streamed */
  is_streaming?: boolean;
  /** Whether response generation is complete */
  is_complete?: boolean;
  /** Number of requests made */
  usage_requests?: number | null;
  /** Number of tokens in the request */
  usage_request_tokens?: number | null;
  /** Number of tokens in the response */
  usage_response_tokens?: number | null;
  /** Total number of tokens used */
  usage_total_tokens?: number | null;
  /** Additional usage details (structured; stored as JSON text) */
  usage_details?: unknown | null;
}

export interface ModelResponseWriteAPI extends ScopedNodeWriteAPI {
  /** Name of the model that generated this response */
  model_name?: string | null;
  /** Whether response is being streamed */
  is_streaming?: boolean;
  /** Whether response generation is complete */
  is_complete?: boolean;
  /** Number of requests made */
  usage_requests?: number | null;
  /** Number of tokens in the request */
  usage_request_tokens?: number | null;
  /** Number of tokens in the response */
  usage_response_tokens?: number | null;
  /** Total number of tokens used */
  usage_total_tokens?: number | null;
  /** Additional usage details (structured; stored as JSON text) */
  usage_details?: unknown | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ModelResponseReadAPISchema: z.ZodType<ModelResponseReadAPI> = ScopedNodeReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  model_name: z.string().nullable().optional(),
  provider_name: z.string().nullable().optional(),
  is_streaming: z.boolean().optional(),
  is_complete: z.boolean().optional(),
  usage_requests: z.number().nullable().optional(),
  usage_request_tokens: z.number().nullable().optional(),
  usage_response_tokens: z.number().nullable().optional(),
  usage_total_tokens: z.number().nullable().optional(),
  usage_details: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
}).passthrough();

export const ModelResponseWriteAPISchema: z.ZodType<ModelResponseWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  model_name: z.string().nullable().optional(),
  is_streaming: z.boolean().optional(),
  is_complete: z.boolean().optional(),
  usage_requests: z.number().nullable().optional(),
  usage_request_tokens: z.number().nullable().optional(),
  usage_response_tokens: z.number().nullable().optional(),
  usage_total_tokens: z.number().nullable().optional(),
  usage_details: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
}).passthrough();
